export default __webpack_public_path__ + "static/media/black-star.c1e6eefc.svg";